<template>
  <transition name="fade">
    <div
      v-if="count > 0"
      class="new-messages-alert"
      @click="emit('click')"
    >
      <span class="chevron"> 
        <DoubleRightOutlined style="transform: rotate(90deg); display: inline-block;" />
      </span>
      <span v-if="count == 1">{{ count }} mensaje nuevo</span>
      <span v-else>{{ count }} mensajes nuevos</span>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { DoubleRightOutlined } from '@ant-design/icons-vue';

const props = defineProps<{
  count: number;
}>();

const emit = defineEmits(["click"]);

function emitClick() {
  emit("click");
}
</script>

<style lang="sass" scoped>
.new-messages-alert
  position: absolute
  left: 41%
  transform: translateX(-50%)
  bottom: 110px
  background: white
  padding: 4px 14px
  border-radius: 20px
  font-size: 14px
  color: #FF4D4F
  // font-weight: 600
  display: flex
  align-items: center
  gap: 6px
  // border: 1px solid #f5c7c7
  box-shadow: 0 2px 6px rgba(0,0,0,0.1)
  cursor: pointer
  z-index: 900

.chevron
  font-size: 12px
  transform: translateY(-2px)
  margin: 4px 5px 0

/* Animaciones de fade */
.fade-enter-active,
.fade-leave-active
  transition: opacity .2s ease

.fade-enter-from,
.fade-leave-to
  opacity: 0
</style>
